import { GetterTree } from "vuex";
import { RootState } from "../types";
import { ScheduleMeeting } from "./types";

export const getters: GetterTree<ScheduleMeeting, RootState> = {};
